import { LitElement, html, css } from 'lit';
import { premiumService } from '../core/services/premium.service.js';

/**
 * Componente guard para verificar acesso premium
 * Exibe conteúdo apenas para usuários premium
 */
export class PremiumGuard extends LitElement {
  
  static styles = css`
    :host {
      display: contents;
    }
    
    .premium-required {
      padding: 2rem;
      /* Compensação da navbar fixa — quando o usuário não é premium,
         este conteúdo é renderizado no Shadow DOM e não recebe o padding-top
         global do style.css. O margin-top garante que não fique oculto
         atrás da top-navbar (position: fixed). */
      margin-top: calc(var(--navbar-height, 4rem) + 1rem);
      text-align: center;
      background: var(--bg-surface-secondary, #1D2740);
      border-radius: var(--radius-input, 12px);
      border: 2px dashed var(--border, #26304A);
    }
    
    .premium-icon {
      font-size: 3rem;
      margin-bottom: 1rem;
    }
    
    .premium-title {
      font-size: 1.5rem;
      font-weight: bold;
      margin-bottom: 1rem;
      color: var(--text-primary, #F4F7FF);
    }
    
    .premium-message {
      color: var(--text-disabled, #6E7A96);
      margin-bottom: 1.5rem;
    }
    
    .upgrade-button {
      background: var(--cta-primary, #FF8A3D);
      color: var(--text-primary, #F4F7FF);
      border: none;
      padding: 0.75rem 2rem;
      border-radius: var(--radius-badge, 999px);
      font-weight: bold;
      cursor: pointer;
      transition: transform 0.2s;
    }
    
    .upgrade-button:hover {
      transform: translateY(-2px);
    }
  `;
  
  static properties = {
    isPremium: { type: Boolean },
    loading: { type: Boolean }
  };
  
  constructor() {
    super();
    this.isPremium = false;
    this.loading = true;
  }
  
  async connectedCallback() {
    super.connectedCallback();
    await this.checkPremiumStatus();
  }
  
  /**
   * Verifica status premium do usuário (com cache)
   */
  async checkPremiumStatus() {
    try {
      this.isPremium = await premiumService.isPremium();
    } catch (error) {
      console.error('Erro ao verificar premium:', error);
      this.isPremium = false;
    } finally {
      this.loading = false;
    }
  }
  
  /**
   * Exibe modal de upgrade
   */
  showUpgradeModal() {
    // Dispara evento para mostrar modal de upgrade
    this.dispatchEvent(new CustomEvent('show-upgrade-modal', {
      bubbles: true,
      composed: true
    }));
  }
  
  render() {
    if (this.loading) {
      return html`
        <div class="has-text-centered">
          <div class="button is-loading is-white"></div>
          <p>Verificando acesso...</p>
        </div>
      `;
    }
    
    if (!this.isPremium) {
      return html`
        <div class="premium-required">
          <div class="premium-icon">🔐</div>
          <div class="premium-title">Acesso Premium Necessário</div>
          <div class="premium-message">
            Esta funcionalidade está disponível apenas para usuários premium.
            <br>Entre em contato com o administrador para liberar seu acesso.
          </div>
          <button class="upgrade-button" @click="${this.showUpgradeModal}">
            Solicitar Acesso Premium
          </button>
        </div>
      `;
    }
    
    // Renderiza conteúdo se usuário tem premium
    return html`<slot></slot>`;
  }
}

customElements.define('premium-guard', PremiumGuard);